const list = [
  {country: "pt-br"},
  {country: "es-ar"},
  {country: "en-ar"},
  {country: "es-ec"},
  {country: "en-ec"},
  {country: "en-bs"},
  {country: "en-gy"},
  {country: "es-gy"},
  {country: "en-bb"},
  {country: "en-jm"},
  {country: "en-bz"},
  {country: "es-mx"},
  {country: "en-mx"},
  {country: "en-br"},
  {country: "es-py"},
  {country: "en-py"},
  {country: "es-bo"},
  {country: "en-bo"},
  {country: "es-pe"},
  {country: "en-pe"},
  {country: "en-ca"},
  {country: "fr-ca"},
  {country: "en-tt"},
  {country: "es-cl"},
  {country: "en-cl"},
  {country: "es-uy"},
  {country: "en-uy"},
  {country: "es-co"},
  {country: "en-co"},
  {country: "en-al"},
  {country: "sq-al"},
  {country: "en-ie"},
  {country: "en-am"},
  {country: "fa-am"},
  {country: "hy-am"},
  {country: "en-kv"},
  {country: "sq-kv"},
  {country: "sr-kv"},
  {country: "az-az"},
  {country: "en-az"},
  {country: "ru-az"},
  {country: "mk-mk"},
  {country: "sq-mk"},
  {country: "en-mk"},
  {country: "fr-be"},
  {country: "nl-be"},
  {country: "en-be"},
  {country: "nl-nl"},
  {country: "en-nl"},
  {country: "bs-ba"},
  {country: "en-ba"},
  {country: "pt-pt"},
  {country: "en-pt"},
  {country: "en-hr"},
  {country: "hr-hr"},
  {country: "en-rs"},
  {country: "sr-rs"},
  {country: "el-cy"},
  {country: "en-cy"},
  {country: "tr-cy"},
  {country: "es-es"},
  {country: "en-es"},
  {country: "pt-fr"},
  {country: "fr-fr"},
  {country: "en-fr"},
  {country: "tr-tr"},
  {country: "en-tr"},
  {country: "fa-tr"},
  {country: "el-gr"},
  {country: "en-gr"},
  {country: "en-gb"},
  {country: "it-it"},
  {country: "en-it"},
  {country: "en-il"},
  {country: "he-il"},
  {country: "ar-il"},
  {country: "ar-ae"},
  {country: "en-ae"},
  {country: "fa-ae"},
  {country: "en-ir"},
  {country: "fa-ir"},
  {country: "pt-ao"},
  {country: "en-ao"},
  {country: "rw-rw"},
  {country: "en-rw"},
  {country: "fr-rw"},
  {country: "fr-cm"},
  {country: "en-cm"},
  {country: "fr-sn"},
  {country: "en-sn"},
  {country: "pt-cv"},
  {country: "en-cv"},
  {country: "en-tz"},
  {country: "fr-cd"},
  {country: "en-cd"},
  {country: "en-za"},
  {country: "am-et"},
  {country: "en-et"},
  {country: "en-ug"},
  {country: "en-ke"},
  {country: "en-zm"},
]

module.exports = list;